import React from "react";
import { Link } from "react-router-dom";
import { Alert, Button } from "@mui/material";
import DoNotDisturbOnOutlinedIcon from "@mui/icons-material/DoNotDisturbOnOutlined";
import { useTranslation } from "react-i18next";
import { StatusCard } from "./marketing/MarketingParts";

export default function PaymentCancel() {
  const { t } = useTranslation();
  return (
    <StatusCard
      icon={<DoNotDisturbOnOutlinedIcon />}
      tone="warning"
      title={t("mkp_cancel_title")}
      actions={
        <Button variant="contained" size="large" component={Link} to="/plans">
          {t("mkp_back_plans")}
        </Button>
      }
    >
      <Alert severity="warning">{t("mkp_cancel_msg")}</Alert>
    </StatusCard>
  );
}
